// Environment detection utility
export const getEnvironment = () => {
  // Check for explicit environment variable
  if (process.env.REACT_APP_ENV) {
    return process.env.REACT_APP_ENV;
  }
  
  // Check for NODE_ENV
  if (process.env.NODE_ENV === 'production') {
    return 'production';
  }
  
  if (process.env.NODE_ENV === 'testing') {
    return 'testing';
  }
  
  // Default to development
  return 'development';
};

export const isProduction = () => getEnvironment() === 'production';
export const isTesting = () => getEnvironment() === 'testing';
export const isDevelopment = () => getEnvironment() === 'development';

// Database collection prefixes for environment separation
export const getCollectionPrefix = () => {
  const env = getEnvironment();
  switch (env) {
    case 'production':
      return ''; // No prefix for production
    case 'testing':
      return 'testing_';
    case 'development':
      return 'dev_';
    default:
      return 'dev_';
  }
};

// Get environment-specific configuration
export const getEnvironmentConfig = () => {
  const env = getEnvironment();
  
  return {
    environment: env,
    isProduction: isProduction(),
    isTesting: isTesting(),
    isDevelopment: isDevelopment(),
    collectionPrefix: getCollectionPrefix(),
    debugMode: !isProduction(),
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
    domain: process.env.REACT_APP_DOMAIN || 'localhost:3000'
  };
};

